































import { Component, Vue, Watch } from 'vue-property-decorator'
import Utils from '@/utils'

@Component
export default class Breadcrumb extends Vue {
  public itemsBreadcrumb: any = []

  @Watch('$store.state.activeProject')
  @Watch('$store.state.activeProduct')
  @Watch('$store.state.activeLang')
  @Watch('$route')
  private updateBreadcrumb() {
    const breadcrumb = this.$route
    const items: any = []
    const project = this.$store.state.activeProject
    const product = this.$store.state.activeProduct
    const workModule = Utils.getCurrentWorkModule(product, this.$route.params.workModuleCode)

    breadcrumb.matched.forEach((r, index) => {
      const newLabel = r.meta.label.replace(
        /::(\w+)::/g,
        (s: string, key: string) => {
          if (breadcrumb.params[key]) {
            return breadcrumb.params[key]
          } else if (key.split('_')[0] === 'i18n') {
            return this.$i18n.t(`breadcrumb_component.${key.split('_')[1]}`)
          } else if (key === 'projectName') {
            return breadcrumb.params.projectId === project.id
              ? project.name
              : 'Proyecto'
          } else if (key === 'productTitle') {
            return breadcrumb.params.productId === product.id
              ? product.title
              : 'Producto'
          } else if (key === 'workModuleTitle' && workModule) {
            if (r.name === 'Preview') {
              return breadcrumb.params.workModuleCode === workModule.code
                ? `${this.$i18n.t('breadcrumb_component.unitPreviewLabel')} ${workModule.title}` : ''
            } else {
              return breadcrumb.params.workModuleCode === workModule.code
                ? `${workModule.title}` : ''
            }
          } else {
            return s
          }
        }
      )

      const uri = r.path.replace(/:(\w+)/g, (s: string, key: string) => {
        return breadcrumb.params[key] || s
      })
      const item = {
        text: newLabel,
        to: r.path !== '' ? uri : r.redirect,
        active: breadcrumb.matched.length - 1 === index
      }
      items.push(item)
    })

    this.itemsBreadcrumb = items
  }

  created() {
    this.updateBreadcrumb()
  }
}
